// Resolves what the reserve flow should do with a POST /whitelabel/checkout
// response. The endpoint has two success shapes:
//   - Stripe (default / un-ramped): { message, session: { url } } → pay via Stripe.
//   - Buyer-credit redemption (Phase 6b, when the partner is ramped and the buyer
//     holds a covering credit): { success, creditApplied: true, reserved: true,
//     propertyId } with NO session → the property is already reserved, go straight
//     to the success page (no Stripe).
// Anything else is an error. Kept as a pure function so the branching is unit
// tested without mounting the Property page.

export type CheckoutOutcome =
  | { kind: "credit"; propertyId: string }
  | { kind: "stripe"; url: string }
  | { kind: "error" };

export function resolveCheckoutOutcome(
  response: any,
  fallbackPropertyId?: string
): CheckoutOutcome {
  if (response && response.creditApplied === true && response.reserved === true) {
    const propertyId = String(response.propertyId || fallbackPropertyId || "");
    if (propertyId) {
      return { kind: "credit", propertyId };
    }
    return { kind: "error" };
  }

  if (
    response &&
    response.session &&
    typeof response.session.url === "string" &&
    response.session.url
  ) {
    return { kind: "stripe", url: response.session.url };
  }

  return { kind: "error" };
}
